import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { ApiRestService } from './api-rest.service';

import { ApiOptionsInterface, ApiUserItem, ApiUserList, ApiUserORSList } from './api.interface';

@Injectable()
export class ApiUserService extends ApiRestService {

  private relativeUrl = '/users/';

  constructor(http: HttpClient) { super(http); }

  public getUser(id: number | string, options?: ApiOptionsInterface): Observable<ApiUserItem> {

    return this.getItem(this.relativeUrl, id, options);
  }

  public getUsers(options?: ApiOptionsInterface): Observable<ApiUserList> {

    return this.getList(this.relativeUrl, options);
  }

  public save(_id: string, payload, etag?: string, options?: ApiOptionsInterface): Observable<ApiUserItem> {
    return this.patch(this.relativeUrl, _id, payload, options, etag);
  }

  public getAvatar(id: number | string ) {

    const options: ApiOptionsInterface = {
      query: {
        projection: { 'avatar': 1 }
      },
    };
    return this.getItem(this.relativeUrl, id, options);
  }
  /**
   * Moved to observations?
   * @param activity 
   * @param options 
   * @returns 
   */
  public getUserObservations(activity: string, options?: ApiOptionsInterface): Observable<ApiUserORSList> {

    return this.getList('/'+activity+'/observations/user', options);
  }

  public getObservationsForUser(activity: string, person_id: number, options?: ApiOptionsInterface, ): Observable<ApiUserORSList> {
    return this.getList('/'+activity+'/observations/aggregate/user/reports?aggregate={"$person_id": '+person_id+'}', options);
  }

}
